export var ie11ReadOnlyClickHandler = function ie11ReadOnlyClickHandler(event) {
  return event.currentTarget && event.currentTarget.blur();
};